import { ContractStage } from '../../../../../models/Entities/Contracts/ContractStage';
import { ContractStageItemViewModel } from '../../../../../models/Entities/Contracts/ContractStageItemViewModel';
import { AppState } from '../../../../../redux/reducers';

interface IProps {
    ContractStage: ContractStage;
}

interface ConnectedProps {
    StageItems: ContractStageItemViewModel[];
}

export type Props = IProps & ConnectedProps;

export const mapStateToProps = (_state: AppState, ownProps: IProps) => {
    const stageItems = ownProps.ContractStage?.contractStageItems || [];
    return {
        StageItems: stageItems.sort((a, b) =>
            (a.ermProtocolVisitId || 0) - (b.ermProtocolVisitId || 0)
        )
    };
};

export const mapDispatchToProps = {};
